/** allowedChildren가 빈 값이 아닌 editorComponents들 */
const ALL_BASIC_DISALLOWED_ANCESTORS = [
  'a',
  'tabButton',
  'carousel',
  'video',
  'accordionButton',
];

/** allowedChildren가 빈 값이 아닌 custom editorComponents들 */
const ALL_CUSTOM_DISALLOWED_ANCESTORS = [
  'grid',
];

const ALL_DISALLOWED_ANCESTORS = [
  ...ALL_BASIC_DISALLOWED_ANCESTORS,
  ...ALL_CUSTOM_DISALLOWED_ANCESTORS,
];

export const getDisallowedAncestors = (excludedIds?: string[]): string[] => {
  return ALL_DISALLOWED_ANCESTORS.filter((id) => !(excludedIds ?? []).some((excludedId) => excludedId === id));
};
